import React from 'react';
import { useTranslation } from 'react-i18next';
import { User } from 'lucide-react';
import { getInspectionDriverSelfieSources, normalizeMediaDataUrl } from '@/utils/inspectionDisplay';

/**
 * Driver verification selfie taken during peritaje (visible to admins only).
 */
export default function InspectionDriverSelfieSection({ inspection, title }) {
  const { t, i18n } = useTranslation();
  const { imageUrl, takenAt } = getInspectionDriverSelfieSources(inspection);

  if (!imageUrl) return null;

  const dateLocale = (i18n.language || '').startsWith('en') ? 'en-US' : 'es-ES';
  const takenLabel = takenAt
    ? new Date(takenAt).toLocaleString(dateLocale, {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : null;

  return (
    <div className="pt-4 border-t">
      <h4 className="font-semibold mb-3 flex items-center gap-2">
        <User className="w-4 h-4" />
        {title || t('inspections_driver_selfie_title')}
      </h4>
      <div className="flex flex-col sm:flex-row sm:items-start gap-4">
        <img
          src={normalizeMediaDataUrl(imageUrl)}
          alt={t('inspections_driver_selfie_alt')}
          className="w-40 h-40 object-cover rounded-lg border bg-gray-50 cursor-pointer hover:opacity-90"
          onClick={() => window.open(normalizeMediaDataUrl(imageUrl), '_blank')}
        />
        <div className="text-sm text-gray-600 space-y-1">
          <p>{t('inspections_driver_selfie_hint')}</p>
          {takenLabel && (
            <p className="text-gray-500">
              {t('inspections_driver_selfie_taken_at', { date: takenLabel })}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
